module.exports = __webpack_public_path__ + "tc.svg?1fb6c67d2b87c7cf99b4b06a0f47925e";